import { render, staticRenderFns } from "./SavedFilterTitle.vue?vue&type=template&id=6e4c4de2"
import script from "./SavedFilterTitle.vue?vue&type=script&lang=js"
export * from "./SavedFilterTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports